import React from "react";
import style from "./AppPreview.module.scss";
interface IAppPopup {
  text?: string;
  store?: string;
  setIsShow: (params: boolean) => void;
}
const AppPopup = ({
  text,
  store,
  setIsShow
}: IAppPopup) => {
  return <div className={style.popup} data-sentry-component="AppPopup" data-sentry-source-file="AppPopup.tsx">
      <div className={style.alert_box}>
        <p>
          {text ?? `By clicking here, users will be taken to the specific ${store} to download your App.`}
        </p>
        <button onClick={() => setIsShow(false)}>Got it</button>
      </div>
    </div>;
};
export default AppPopup;